<template>
  <v-toolbar dark app class="primary honey-toolbar-class" id="honeyToolbar">
    <v-toolbar-side-icon class="hidden-lg-and-up" @click.stop="toggleDrawer" />
    <v-toolbar-title
      :style="$vuetify.breakpoint.smAndUp ? '' : 'min-width: 72px'"
      class="ml-0"
    >
      <img
        src="/images/TulipLogo.png"
        alt="Tulip"
        style="width: 100px;padding-top: 10px;"
      />
    </v-toolbar-title>

    <v-spacer />
    <br />
    <v-menu
      attach="honeyToolbar"
      style="z-index:20;"
      bottom
      scrollable
      offset-y
      content-class="honey-popup-notif"
      :nudge-left="400"
      origin="top right"
      :close-on-content-click="false"
      transition="scale-transition"
      v-model="showTaskNotification"
      v-if="can('NOTIFICATION')"
    >
      <template slot="activator">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="readNotification()">
            <v-badge
              v-model="showNotificationBadge"
              color="secondary"
              right
              overlap
            >
              <span
                slot="badge"
                :style="$vuetify.dark ? 'color: #000' : 'color: #fff'"
                >{{ unreadNotifications }}</span
              >
              <v-icon color="accent"
                >{{
                  showNotificationBadge
                    ? 'notifications_active'
                    : 'notifications'
                }}
              </v-icon>
            </v-badge>
          </v-btn>
          <span>Notifications</span>
        </v-tooltip>
      </template>
      <div class="honey--notifications" id="honey-notifications-id">
        <v-toolbar dark class="primary" dense card>
          <div class="text-lg-left beez-bold ">
            Notification Center
          </div>
          <v-spacer />
          <v-btn
            flat
            icon
            @click="showTaskNotification = !showTaskNotification"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <template>
          <v-toolbar dense>
            <v-flex>
              <div class="text-lg-left beez-bold">
                Notifications
              </div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="clearAllNotification()">
              <v-icon>delete_sweep</v-icon>
            </v-btn>
          </v-toolbar>
          <v-flex v-for="(item, index) in notifications" :key="index">
            <template>
              <v-expand-transition>
                <v-card :key="item + 'card-detail' + index">
                  <v-card-title class="honey--notifications text">
                    <v-layout row wrap>
                      <v-flex xs1 style="text-align: center;">
                        <v-avatar tile>
                          <v-icon :color="item.color">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs9 style="padding-left: 5px;">
                        <v-flex xs12>
                          <div class="body-2 text-left">
                            {{ item.message }}
                          </div>
                        </v-flex>
                        <v-flex xs12>
                          <div class="caption text-left">
                            {{ item.timestamp }}
                          </div>
                        </v-flex>
                      </v-flex>
                      <v-flex xs2 style="text-align: center;">
                        <v-btn flat icon @click="clearNotification(index)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text v-if="item.description">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div class="body-1 text-left ">
                          {{ item.description }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="honey--notifications text">
                    <v-flex
                      xs10
                      offset-xs1
                      v-for="(action, index) in item.actions"
                      :key="index"
                    >
                      <template>
                        <v-btn
                          flat
                          :class="$vuetify.dark ? 'secondary' : 'primary'"
                          :outline="$vuetify.dark"
                          @click="notificationAction(action)"
                        >
                          <span class="text-capitalize">
                            {{ action.name }}
                          </span>
                        </v-btn>
                      </template>
                    </v-flex>
                    <v-flex xs1></v-flex>
                  </v-card-actions>
                  <v-divider></v-divider>
                </v-card>
              </v-expand-transition>
            </template>
          </v-flex>
          <v-flex v-if="notifications.length == 0">
            <v-card class="pa-4">
              <v-layout row wrap>
                <v-flex xs12>
                  <span>No notifications!</span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </template>
      </div>
    </v-menu>
    <br />
    <v-tooltip bottom>
      <v-btn slot="activator" flat icon @click="openNewWindow()">
        <v-icon color="accent">help</v-icon>
      </v-btn>
      <span>Tulip Help</span>
    </v-tooltip>
  </v-toolbar>
</template>

<style scoped>
.flavor-select {
  max-width: 256px;
}

.honey-toolbar-class {
  z-index: 12;
}

.honey-help-class {
  border-radius: 10px;
  right: 6px !important;
  top: 75px !important;
}

.honey-popup {
  border-radius: 10px;
  top: 75px !important;
  right: 10px !important;
  /*max-width: 400px !important;*/
}

.honey-popup-notif {
  top: 75px !important;
  border-radius: 10px;
  right: 10px !important;
  /*max-width: 500px !important;*/
}

.honey--notifications {
  width: 500px;
  text-align: left;
}

.help--frame {
  width: 100%;
  background-color: white;
  /* text-align: justify; */
}

.honey--notifications.text {
  padding: 5px 0px 0px 0px !important;
}

.chat-box {
  width: 370px;
  height: calc(100% - 120px);
  max-height: 590px;
  position: fixed;
  right: 25px;
  bottom: 100px;
  box-sizing: border-box;
  box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
  transition: 0.3s ease-in-out;
  border-radius: 10px;
}

.toolbar-gradient {
  /*background-image: linear-gradient(to right, #ffd900, #ff9400, #e94057);*/
}
</style>

<script>
import { mapGetters, mapState } from 'vuex'
// import Buzz from '@/components/buzz/Buzz'

// eslint-disable-next-line no-unused-vars
window.onresize = function(event) {
  let windowHeight = window.innerHeight
  if (!this.showTaskNofitication) {
    let notifHeight = (windowHeight * 90) / 100
    document.getElementById('honey-notifications-id').style.maxHeight =
      notifHeight.toString() + 'px'
  }
}

export default {
  // components: { Buzz },
  data: function() {
    return {
      tabNotification: 1,
      tabTask: 0,
      showTaskNotification: false,
      taskNotificationTabModel: 1,
      showChat: false,
      showHelp: false,
      taskLoader: false
    }
  },
  mounted() {},
  computed: {
    ...mapState({
      notifications: state => state.socket.notifications,
      unreadNotifications: state => state.socket.unreadNotifications,
      showNotificationBadge: state => state.socket.showNotificationBadge,
      unreadChat: state => state.socket.unreadChat,
      showChatBadge: state => state.socket.showChatBadge,
      myTasks: state => state.tasks.claimedTasks
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  methods: {
    toggleDrawer: function() {
      this.$emit('toggleDrawer')
    },
    openTask(item) {
      this.$router
        .push({
          name: 'task-action',
          params: { hexId: item.id }
        })
        .catch()
    },
    gotoHome: function() {
      this.$router.push({ name: 'home' }).catch()
    },

    clearNotification(index) {
      this.$store.dispatch('clearNotification', index)
    },

    clearAllNotification() {
      this.$store.dispatch('clearAllNotification')
      this.showTaskNotification = !this.showTaskNotification
    },

    readNotification() {
      this.$store.dispatch('readNotification')
      if (!this.showTaskNotification) {
        let notifHeight = (window.innerHeight * 80) / 100
        document.getElementById('honey-notifications-id').style.maxHeight =
          notifHeight.toString() + 'px'
      }
    },

    readChat() {
      this.$store.dispatch('readChat')
      if (!this.showChat) {
        let chatHeight = (window.innerHeight * 70) / 100
        document.getElementById('chat_container').style.height =
          chatHeight.toString() + 'px'
      }
    },
    notificationAction(action) {
      if (action.queryParam) {
        this.$router
          .push({
            name: action.gotoUrl,
            query: { search: action.queryParam }
          })
          .catch()
      } else if (action.objectId) {
        this.$router
          .push({
            name: action.gotoUrl,
            params: { hexId: action.objectId }
          })
          .catch()
      }
      this.showTaskNotification = !this.showTaskNotification
    },

    openNewWindow() {
      this.showHelp = !this.showHelp
      window.open(
        'https://docs.beezlabs.com/2021.11.01.1101/introduction/introduction.html'
      )
    }
  }
}
</script>
